
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  name: "alert-badge",
})
export default class AlertBadge extends Vue {
  @Prop({ required: false, type: String, default: "de" })
  private readonly locale!: string;

  @Prop({ required: true, type: Date })
  private readonly lastCheck!: Date;

  @Prop({ required: false, type: Number, default: 150 })
  private readonly maxAlerts!: number;

  @Prop({ required: false, type: Number, default: 99 })
  private readonly maxDisplayedAlerts!: number;
}
